







import avatarBlock from '@/components/Ui/ActiveInfoPage/Blocks/avatar.vue'
import Vue from 'vue'
export default Vue.extend({
  props: {
    scope: {},
    options: {}
  },
  components: {
    avatarBlock
  }
})
